import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { ListeDocumentsComponent } from './liste-documents.component';
import { ListeDocumentsService } from './liste-documents.service';
import { DocumentModule } from './document/document.module';

@NgModule({
    declarations: [ 
        ListeDocumentsComponent
    ],
    imports: [ 
        DocumentModule,
        BrowserModule,
        FormsModule,
        HttpClientModule
     ],
    exports: [
        ListeDocumentsComponent
    ],
    providers: [ ListeDocumentsService ]
})
export class ListeDocumentsModule{}